import { render, staticRenderFns } from "./QuickFeatures.vue?vue&type=template&id=56b1c922&scoped=true"
import script from "./QuickFeatures.vue?vue&type=script&lang=js"
export * from "./QuickFeatures.vue?vue&type=script&lang=js"
import style0 from "./QuickFeatures.vue?vue&type=style&index=0&id=56b1c922&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b1c922",
  null
  
)

export default component.exports